const generateClientInfo = () => ({
    BusinessUnit: 'ISW',
    ClientCode: 'WALNI',
});

const generateComplainantInfo = (complainant, isAnon) => {
    // This interprets the role dropdown value and sets the PositionTitle as one of the following values for proper grammar and capitalization
    const positionTitles = {
        worker: 'Worker',
        anon: 'Anonymous',
        thirdParty: 'Third Party',
    };
    const PositionTitle = positionTitles[complainant.role];

    return {
        PreferredLanguage: isAnon ? 'en' : complainant.language,
        EntityType: 'ULE',
        LicenseNumber: '',
        FirstName: isAnon ? 'Anonymous' : complainant.firstName,
        LastName: isAnon ? 'Anonymous' : complainant.lastName,
        AddressTypeCode: 'MLG',
        Street1: complainant.address1,
        Street2: complainant.address2,
        City: complainant.city,
        CountyCode: Number(complainant.county) || '',
        StateCode: complainant.state,
        Zip: complainant.zipCode,
        CountryCode: 'US',
        Phone: isAnon ? '000-000-0000' : complainant.phone,
        PhoneExtension: '',
        AlternatePhone: '',
        AlternatePhoneExtension: '',
        Fax: '',
        Email: isAnon ? 'anonymous@email.com' : complainant.email,
        AlternateEmail: '',
        PositionTitle,
    };
};

const generateComplaintInfo = complaint => ({
    ComplaintDescription: complaint.description,
});

const generateRespondentInfo = respondent => ({
    EntityType: 'ULE',
    LicenseNumber: '',
    FirstName: '',
    LastName: respondent.name, // Employer name is mapped here
    AddressTypeCode: 'MLG',
    Street1: respondent.address1,
    Street2: respondent.address2,
    City: respondent.city,
    CountyCode: Number(respondent.county) || '',
    StateCode: respondent.state,
    Zip: respondent.zipCode,
    CountryCode: 'US',
    Phone: respondent.phone,
    PhoneExtension: '',
    AlternatePhone: respondent.contactPhone,
    AlternatePhoneExtension: '',
    Fax: '',
    Email: respondent.email,
    AlternateEmail: respondent.contactEmail,
    DBAName: '',
    ContactPerson: `${respondent.contactFirstName} ${respondent.contactLastName}`,
});

const generateAllegations = allegations => (allegations || []).map(
    value => ({
        TypeCode: value,
        TypeCodeOther: '',
    }),
);

// TODO: Remove once Aithent removes on their end (this app does not have a preliminary question)
const generatePreliminaryQuestion = () => [{
    QuestionnaireType: 'HLSPREQ',
    QuestionTypeCode: 'HLSCMPQC09',
    ResponseType: 'O',
    Answer: 'HLSCMPQC09NO',
}];

const generateQuestions = additionalQuestions => {
    const getQuestion = (QuestionTypeCode, ResponseType, Answer) => Answer ? {
        QuestionnaireType: 'ISWCAI',
        QuestionTypeCode,
        ResponseType,
        Answer,
        Explanation: '',
    } : undefined;

    const results = [];

    if (additionalQuestions.dateStartWork?.length) {
        results.push(getQuestion('ISWCMPQS2', 'D', additionalQuestions.dateStartWork));
    }
    if (additionalQuestions.dateEndWork?.length) {
        results.push(getQuestion('ISWCMPQS3', 'D', additionalQuestions.dateEndWork));
    }
    if (additionalQuestions.dateStartComplaint?.length) {
        results.push(getQuestion('ISWCMPQS01', 'D', additionalQuestions.dateStartComplaint));
    }
    if (additionalQuestions.dateEndComplaint?.length) {
        results.push(getQuestion('ISWCMPQS02', 'D', additionalQuestions.dateEndComplaint));
    }

    return results;
};

const generateDocuments = documents => (documents || []).map(
    ({
        DocumentType,
        FileName,
        FileData,
        FileDescription,
    }) => ({
        ReferenceType: '',
        DocumentType,
        DocumentName: FileName,
        Document: FileData,
        Comments: FileDescription,
    }),
);

const generateAttestation = () => [{
    ReferenceType: 'CMP',
    AttestationCode: 'ISWATT1',
}];

export default context => {
    const appState = context.rootState.appState;

    const ClientInformation = generateClientInfo();
    const ComplainantInformation = generateComplainantInfo(appState.complainant, context.rootGetters['appState/isAnonymous']);
    const ComplaintInformation = generateComplaintInfo(appState.complaint);
    const RespondentInformation = generateRespondentInfo(appState.respondent);
    const Allegation = generateAllegations(appState.allegations);
    const PreliminaryQuestion = generatePreliminaryQuestion();
    const Questions = generateQuestions(appState.additionalQuestions);
    const Documents = generateDocuments(appState.documents);
    const Attestation = generateAttestation();

    return {
        ClientInformation,
        ComplainantInformation: JSON.parse(JSON.stringify(ComplainantInformation)),
        ComplaintInformation,
        RespondentInformation,
        Allegation,
        PreliminaryQuestion,
        Questions: JSON.parse(JSON.stringify(Questions)),
        Documents,
        Attestation,
    };
};